import { render, staticRenderFns } from "./PharmacyGroupTechnicianDetails.vue?vue&type=template&id=2d0498e0"
import script from "./PharmacyGroupTechnicianDetails.vue?vue&type=script&lang=js"
export * from "./PharmacyGroupTechnicianDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports